import React, { useState, useRef, useEffect } from "react";
import { DownArrow } from "../../assets/icons/DownArrow";
import { Link } from "react-router-dom";

type SortOption = {
  value: string;
  label: string;
  to: string;
};

const sortOptions: SortOption[] = [
  { value: "Invoice", label: "Create Invoice", to: "/invoices?openModal=true" },
  { value: "Expense", label: "Create Expense", to: "/expenses?openModal=true" },
  { value: "Inventory", label: "Create Inventory", to: "/inventories/create" },
];

const CreateDropdown: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<SortOption>(
    sortOptions[0],
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleOptionClick = (option: SortOption) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className="relative inline-block w-[160px] text-left"
    >
      <button
        type="button"
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
        className={`flex items-center justify-between gap-2 w-full h-[48px] px-[12px] text-gray-600 lg:text-[14px] text-[13px] text-nowrap font-medium bg-main-white rounded-lg focus:outline-none border border-[#0469C5] ${isOpen && "btn-border-effect"}`}
      >
        QUICK ACTION
        <span
          className={`transition-transform duration-300 ${isOpen && "rotate-180"}`}
        >
          {<DownArrow width="14px" height="14px" />}
        </span>
      </button>

      {isOpen && (
        <div className="animate-slide-down absolute z-10 mt-1 p-[5px] w-full rounded-lg bg-white shadow-lg border border-slate-200 overflow-hidden">
          <div className="rounded-md">
            <ul
              className=""
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {sortOptions.map((option) => (
                <li key={option.value}>
                  <Link
                    to={option.to}
                    onClick={() => handleOptionClick(option)}
                    className={`block px-3 py-3 text-gray-600 hover:text-black text-sm w-full text-left rounded-md border border-transparent hover:bg-slate-100 hover:border-slate-300`}
                    role="menuitem"
                  >
                    {option.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateDropdown;
